import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import { dateOffset, dateParse, serverDateNow } from '@/lib/utils';

var HomePageActivityModel =
/** @class */
function () {
  function HomePageActivityModel(raw) {
    this.id = raw.id;
    this.mode = raw.mode;
    this.name = raw.name;
    this.cover = raw.cover;
    this.join_count = raw.join_count;
    this.rule_url = raw.rule_url;
    this.monitor_apply_start_date = raw.monitor_apply_start_date;
    this.monitor_apply_finish_date = raw.monitor_apply_finish_date;
    this.sign_up_start_date = raw.sign_up_start_date;
    this.sign_up_finish_date = raw.sign_up_finish_date;
    this.sign_in_start_date = raw.sign_in_start_date;
    this.sign_in_finish_date = raw.sign_in_finish_date;
  }

  Object.defineProperty(HomePageActivityModel.prototype, "closeParticipation", {
    get: function get() {
      var serverDate = serverDateNow().valueOf();
      return serverDate >= dateOffset(dateParse(this.sign_up_finish_date), 1).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HomePageActivityModel.prototype, "startParticipation", {
    get: function get() {
      var serverDate = serverDateNow().valueOf();
      return serverDate >= dateParse(this.sign_up_start_date).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HomePageActivityModel.prototype, "closeSignin", {
    get: function get() {
      var serverDate = serverDateNow().valueOf();
      return serverDate >= dateOffset(dateParse(this.sign_in_finish_date), 1).valueOf();
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(HomePageActivityModel.prototype, "status", {
    get: function get() {
      return !this.closeParticipation ? this.startParticipation ? '报名中' : '未开始' : this.closeSignin ? '已结束' : '进行中';
    },
    enumerable: false,
    configurable: true
  });
  return HomePageActivityModel;
}();

export { HomePageActivityModel };